export default {
    finance: {
        loanPrograms: {
            title: "Programas de prestamo",
            create: "Crear programa de prestamo",
            edit: "Editar programa de prestamo",
            details: "Detalles del programa",
            programTitle: "Titulo del programa",
            programLogo: "Logotipo del programa",
            applicationForm: "Formulario de solicitud",
            viewApplications: "Ver solicitudes",
            cooperative: "Cooperativa",
            bank: "Banco",
            status: "Status",
            allStatuses: "Todos los estados",
            active: "Activo",
            inactive: "Inactivo",
            approvalFlowSetting: "Configuracion del flujo de aprobacion",
            concludeBeforeBank: "Concluir una solicitud de prestamo antes de enviarla al banco.",
            allowBankRequestInfo: "Permitir que el banco solicite mas informacion al solicitante.",
            currency: "Moneda",
            loanAmountMin: "Monto del prestamo - Minimo",
            loanAmountMax: "Monto del prestamo - Maximo",
            term: "Plazo",
            yield: "Rendimiento",
            typeOfFinancing: "Tipo de financiamiento",
            gracePeriod: "Periodo de gracia",
            country: "Pais",
            regions: "Regiones",
            crops: "Cultivos",
            dataFields: "Campos de datos",
            dataFieldsConfigured: "Campos de datos configurados para este programa de prestamo",
            signature: "Firma",
            viewSignatureFile: "Ver firma / archivo",
            description: "Descripcion",
            conditionsRequirements: "Condiciones y requisitos",
            digitalSignature: "Firma digital",
            fileUpload: "Carga de archivo",
            failedLoadLoanProgramDetails: "No se pudieron cargar los detalles del programa de prestamo",
            failedLoadLoanProgram: "No se pudo cargar el programa de prestamo",
            failedLoadApplicationForm: "No se pudo cargar el formulario de solicitud",
            loanProgramUpdatedSuccess: "Programa de prestamo actualizado correctamente",
            loanProgramCreatedSuccess: "Programa de prestamo creado correctamente",
            applicationFormUpdatedSuccess: "Formulario de solicitud actualizado correctamente",
            failedUpdateLoanProgram: "No se pudo actualizar el programa de prestamo",
            failedCreateLoanProgram: "No se pudo crear el programa de prestamo",
            failedUpdateApplicationForm: "No se pudo actualizar el formulario de solicitud",
            fillRequiredFields: "Complete todos los campos obligatorios",
            fileUploadRequiredFor: "Se requiere cargar un archivo para",
            selectAtLeastOneOptionFor: "Seleccione al menos una opcion para",
            fieldRequired: "Este campo es obligatorio",
            chooseValidOptionFor: "Elija una opcion valida para",
            enterValidAmountFor: "Ingrese un monto valido para",
            selectValidUnitFor: "Seleccione una unidad valida para",
            step1ProgramDetails: "Paso 1: Detalles del programa",
            step2ApplicationForm: "Paso 2: Formulario de solicitud",
            months: "meses",
            years: "anos",
            days: "dias",
            weeks: "semanas",
            previewForm: "VISTA PREVIA DEL FORMULARIO",
            backUpper: "VOLVER",
            basicInformation: "Informacion basica",
            basicInformationHint: "Ingrese la informacion basica para el programa de prestamo.",
            enterProgramTitle: "Ingrese el titulo del programa",
            attachProgramLogo: "Adjuntar logotipo del programa",
            selectProgramLogoImage: "Seleccione la imagen del logotipo del programa",
            selectFileUploadProgramLogo: "Seleccione el archivo para cargar el logotipo del programa",
            orDragDrop: "o arrastre y suelte aqui",
            removeFile: "Eliminar archivo",
            loanProgramSettings: "Configuraciones del programa de prestamo",
            loanProgramSettingsHint: "Ingrese las configuraciones del programa de prestamo.",
            selectBank: "Seleccione banco",
            applicationApproval: "Aprobacion de solicitud",
            applicationProcess: "Proceso de solicitud",
            loanDetails: "Detalles del prestamo",
            loanDetailsHint: "Ingrese los detalles del prestamo para el programa de prestamo.",
            selectCurrency: "Seleccione moneda",
            enterMinLoanAmount: "Ingrese monto minimo del prestamo",
            enterMaxLoanAmount: "Ingrese monto maximo del prestamo",
            enterHere: "Ingrese aqui",
            interestRate: "Tasa de interes",
            yieldPerYear: "Rendimiento - por ano",
            enterYieldPerYear: "Ingrese rendimiento por ano",
            selectTypeOfFinancing: "Seleccione tipo de financiamiento",
            gracePeriodMax: "Periodo de gracia - Maximo",
            selectCrops: "Seleccione cultivos",
            selectCountry: "Seleccione pais",
            selectRegions: "Seleccione regiones",
            addNewDataField: "AGREGAR NUEVO CAMPO DE DATOS",
            enterProgramDescription: "Ingrese descripcion del programa",
            programApplicationForm: "Formulario de solicitud del programa",
            defineAndManageCustomDataFields: "Defina y gestione campos de datos personalizados para la solicitud de prestamo.",
            addDataField: "AGREGAR CAMPO DE DATOS",
            dataField: "Campo de datos",
            type: "Tipo",
            subdata: "Subdato",
            mandatory: "Obligatorio",
            group: "Grupo",
            yes: "Si",
            no: "No",
            noDataFieldsYet: "Aun no hay campos de datos. Haga clic en AGREGAR CAMPO DE DATOS para crear uno.",
            textField: "Campo de texto",
            textArea: "Area de texto",
            textFieldNumeric: "Campo numerico",
            radioButton: "Boton de opcion",
            checkBoxes: "Casillas de verificacion",
            dropdown: "Lista desplegable",
            measurementUnit: "Unidad de medida",
            attachFile: "Adjuntar archivo",
            digitalSignatureLabel: "Firma digital",
            dataList: "Lista de datos",
            date: "Fecha",
            selectDataType: "Seleccionar tipo de dato",
            fieldTitle: "Titulo del campo",
            groupTitle: "Titulo del grupo",
            enterGroupTitle: "Ingrese el titulo del grupo",
            allowMultipleInputs: "Permitir multiples entradas",
            allowedFileTypes: "Tipos de archivo permitidos",
            imageJpegGifPng: "Imagen (JPEG, GIF, PNG)",
            videoMp4: "Video (MP4)",
            docx: "DOCX",
            options: "Opciones",
            typeHere: "Escriba aqui",
            unitType: "Tipo de unidad",
            selectUnitType: "Seleccione tipo de unidad",
            selectType: "Seleccione tipo",
            allowUserToChangeUnitType: "Permitir al usuario cambiar el tipo de unidad",
            help: "Ayuda",
            writeHelpTextUsers: "Escriba un texto de ayuda para los usuarios.",
            helpText: "Texto de ayuda",
            addHelpTextForThisDataField: "Agregar texto de ayuda para este campo de datos",
            addFieldToGroup: "Agregar campo al grupo",
            cancelUpper: "CANCELAR",
            submitUpper: "ENVIAR",
            groupTitleRequired: "El titulo del grupo es obligatorio",
            atLeastOneFieldRequiredInGroup: "Se requiere al menos un campo en un grupo",
            fieldTitleRequiredForAllGroupFields: "El titulo del campo es obligatorio para todos los campos del grupo",
            atLeastOneOptionRequiredFor: "Se requiere al menos una opcion para",
            atLeastOneFileTypeMustBeSelected: "Debe seleccionar al menos un tipo de archivo",
            fieldTitleRequired: "El titulo del campo es obligatorio",
            atLeastOneOptionRequired: "Se requiere al menos una opcion",
        },
        loanApplications: {
            activityDescription: "Descripcion de la actividad",
            activityLog: "Registro de actividad",
            addAnyInternalNotesOrReviewCommentsAboutThisLoanApplication: "Agregue notas internas o comentarios de revision sobre esta solicitud de prestamo.",
            additionalInformationRequested: "Informacion adicional solicitada",
            additionalLoanRelatedQuestionsAndSupportingDocuments: "Preguntas adicionales relacionadas con el prestamo y documentos de respaldo.",
            additionalQuestions: "Preguntas adicionales",
            address: "Direccion",
            amount: "Monto",
            applicantDetails: "Datos del solicitante",
            applicationHasBeenSentToTheBankForApproval: "La solicitud ha sido enviada al banco para su aprobacion.",
            applicationId: "ID de solicitud",
            applicationIdAndSubmissionDate: "ID de solicitud y fecha de envio",
            apply: "Aplicar",
            approvalProcess: "Proceso de aprobacion",
            approvalProcessHasBeenStartedYouCanNowFillFinalizeContractAndLoanDetails: "Se ha iniciado el proceso de aprobacion. Ahora puede completar Finalizar contrato y Detalles del prestamo.",
            approve: "Aprobar",
            approved: "Aprobado",
            areYouSureYouWantToApproveTheLoanApplication: "Esta seguro de que desea aprobar la solicitud de prestamo?",
            areYouSureYouWantToRejectTheLoanApplication: "Esta seguro de que desea rechazar la solicitud de prestamo?",
            areYouSureYouWantToSendTheApplicationToTheBankForApprovalProcess: "Esta seguro de que desea enviar la solicitud al banco para el proceso de aprobacion?",
            areYouSureYouWantToStartTheApprovalProcess: "Esta seguro de que desea iniciar el proceso de aprobacion?",
            area: "Area",
            areaHa: "Area (ha)",
            attachContractOptional: "Adjuntar contrato (opcional)",
            attachment: "Adjunto",
            back: "Atras",
            cancel: "Cancelar",
            circular: "Circular",
            close: "Cerrar",
            closeUpper: "CERRAR",
            confirm: "Confirmar",
            confirmation: "Confirmacion",
            contract: "Contrato",
            couldNotLoadLoanApplication: "No se pudo cargar la solicitud de prestamo.",
            couldNotSendRequest: "No se pudo enviar la solicitud.",
            couldNotUpdateApplication: "No se pudo actualizar la solicitud.",
            country: "Pais",
            customization: "Personalizacion",
            date: "Fecha",
            dateAndTime: "Fecha y hora",
            describeHere: "Describa aqui",
            description: "Descripcion",
            digitallySigned: "Firmado digitalmente",
            disclaimerTitle: "Aviso legal",
            disbursedAmount: "Monto desembolsado",
            disbursementScheduleFromBankToFarmer: "Calendario de desembolsos del banco al agricultor.",
            doYouWantUsToCollectTheContractSignature: "Desea que recojamos la firma del contrato?",
            doYouWantUsToCollectTheContractSignatureIfYesAttachTheContractOptionalAndWeWillSendItToTheFarmerToSignInTheAppIfNoTheContractIsAlreadySignedOrWillBeSignedOfflineAfterYouAttachAndSaveTheContractWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Desea que recojamos la firma del contrato? Si es asi, adjunte el contrato (opcional) y lo enviaremos al agricultor para firmarlo en la app. Si no, el contrato ya esta firmado o se firmara fuera de linea. Tras adjuntar y guardar, el contrato se enviara al agricultor para firmar; recibira una notificacion cuando este firmado.",
            download: "Descargar",
            dueDate: "Fecha de vencimiento",
            email: "Correo electronico",
            enterHere: "Ingrese aqui",
            error: "Error",
            farm: "Finca",
            farmDetails: "Detalles de la finca",
            farmReports: "Informes de finca",
            farmer: "Agricultor",
            farmerResponse: "Respuesta del agricultor",
            farmerUpdates: "Actualizaciones del agricultor",
            farmReportsSoilDisclaimer: "La informacion de esta seccion es solo de referencia general. No debe sustituir un analisis de suelo profesional en laboratorio. Use esta informacion solo si no dispone de otras opciones de analisis. Consulte siempre a expertos agricolas antes de decidir.",
            farmReportsYieldBullet1: "Es imposible predecir con exactitud el clima de toda una temporada; en algunos casos los agricultores pueden perder toda la cosecha por un granizo o una inundacion (especialmente con el calentamiento global y sus irregularidades).",
            farmReportsYieldBullet2: "Los rendimientos dependen mucho de las practicas de manejo. Por ejemplo, si no se aplican plaguicidas a tiempo o no se riega bien, los rendimientos pueden diferir mucho de las predicciones; esto tambien esta fuera de nuestro control.",
            farmReportsYieldBullet3: "Existen muchos otros factores similares que pueden provocar errores importantes en las predicciones de rendimiento por IA.",
            farmReportsYieldBullet4: "Si el agricultor proporciona rendimientos historicos (modo AVANZADO), las predicciones suelen ser mas precisas que en el modo predeterminado (no AVANZADO).",
            farmReportsYieldUncertaintyIntro: "En nuestras predicciones de rendimiento la incertidumbre puede ser del 100% porque hay muchos factores fuera de nuestro control, entre ellos:",
            forecastedYields: "Rendimientos pronosticados",
            graph: "Grafico",
            yieldsKgAxis: "Rendimientos (kg)",
            yieldForecasts: "Pronosticos de rendimiento",
            farmerUploadedAttachmentS: "El agricultor subio archivo(s) adjunto(s).",
            finalizeContract: "Finalizar contrato",
            financeManagement: "Gestion financiera",
            firstName: "Nombre",
            generatePaymentSchedule: "GENERAR CALENDARIO DE PAGOS",
            geolocation: "Geolocalizacion",
            gracePeriod: "Periodo de gracia",
            gracePeriodType: "Tipo de periodo de gracia",
            historyOfActionsTakenOnThisLoanApplication: "Historial de acciones realizadas en esta solicitud de prestamo.",
            ifYouWantUsToCollectTheApplicantSSignatureChooseYesAndAttachTheContractAfterYouSaveItWillBeSentToTheFarmerToSignInTheAppYouLlReceiveANotificationOnceSignedContractUploadIsOptionalEGIfTheContractIsAlreadySignedOrWillBeSignedOffline: "Si desea que recojamos la firma del solicitante, elija Si y adjunte el contrato. Al guardar, se enviara al agricultor para firmarlo en la app; recibira una notificacion cuando este firmado. La carga del contrato es opcional (p. ej., si ya esta firmado o se firmara fuera de linea).",
            information: "Informacion",
            informationRequestedFromBank: "Informacion solicitada al banco",
            installment: "Cuota",
            installmentDetails: "Detalles de la cuota",
            interestRate: "Tasa de interes",
            ipAddress: "Direccion IP",
            keySoilNutrientLevelsForTheFarm: "Niveles clave de nutrientes del suelo en la finca.",
            landSuitabilityReport: "Informe de idoneidad del terreno",
            lastName: "Apellido",
            loadingData: "Cargando datos...",
            loanAmount: "Monto del prestamo",
            loanApplicationDetails: "Detalles de la solicitud de prestamo",
            loanApplicationHasBeenApproved: "La solicitud de prestamo ha sido aprobada.",
            loanApplicationHasBeenRejected: "La solicitud de prestamo ha sido rechazada.",
            loanApplications: "Solicitudes de prestamo",
            loanDetails: "Detalles del prestamo",
            loanDetailsSummary: "Resumen de los detalles del prestamo.",
            loanDisbursementBankFarmer: "Desembolso del prestamo (Banco -> Agricultor)",
            loanDisbursementPlan: "Plan de desembolso del prestamo",
            loanProgram: "Programa de prestamos",
            loanPrograms: "Programas de prestamos",
            loanRepaymentFarmerBank: "Amortizacion del prestamo (Agricultor -> Banco)",
            loanRepaymentPlan: "Plan de amortizacion del prestamo",
            missingApplicationId: "Falta el ID de la solicitud.",
            moderate: "Moderado",
            notApplicable: "N/A",
            nitrogenContent: "Contenido de nitrogeno",
            noAdditionalQuestions: "No hay preguntas adicionales.",
            noContractIsAlreadySignedOrWillBeSignedOffline: "No: el contrato ya esta firmado o se firmara fuera de linea",
            noMapCoordinatesForThisFarm: "No hay coordenadas de mapa para esta finca.",
            notes: "Notas",
            numberOfDisbursements: "Numero de desembolsos",
            numberOfInstallments: "Numero de cuotas",
            of: "de",
            openFile: "Abrir archivo",
            orDragAndDropHere: "o arrastre y suelte aqui",
            overallLandSuitabilityScoreAndCategory: "Puntuacion y categoria global de idoneidad del terreno.",
            overallScoreForLandSuitability: "Puntuacion global de idoneidad del terreno",
            paid: "Pagado",
            paymentDetails: "Detalles del pago",
            payments: "Pagos",
            pending: "Pendiente",
            phoneNumber: "Telefono",
            phosphorusContent: "Contenido de fosforo",
            pleaseEnterAValidInterestRateToGenerateRepaymentPlan: "Ingrese una tasa de interes valida para generar el plan de amortizacion.",
            pleaseEnterAValidLoanAmountToGenerateDisbursementPlan: "Ingrese un monto de prestamo valido para generar el plan de desembolso.",
            pleaseEnterAValidLoanAmountToGenerateRepaymentPlan: "Ingrese un monto de prestamo valido para generar el plan de amortizacion.",
            pleaseEnterNumberOfInstallmentsToGenerateRepaymentPlan: "Ingrese el numero de cuotas para generar el plan de amortizacion.",
            pleaseEnterYourCommentsOrInstructions: "Ingrese sus comentarios o instrucciones.",
            pleaseProvideSpecificCommentsOrInstructionsInTheTextBoxBelowOnceSubmittedTheFarmerWillBeNotifiedYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Indique comentarios o instrucciones concretos en el cuadro de texto. Al enviar, se notificara al agricultor. Usted recibira una notificacion cuando el agricultor actualice la solicitud.",
            polygon: "Poligono",
            potassiumContent: "Contenido de potasio",
            principalAndInterest: "Capital e intereses",
            print: "Imprimir",
            projectedYieldComparisonByYear: "Comparacion de rendimiento proyectado por ano.",
            provinceState: "Provincia / Estado",
            question: "Pregunta",
            recordsPerPage: "Registros por pagina",
            regionDistrict: "Region / Distrito",
            reject: "Rechazar",
            rejected: "Rechazado",
            repaymentScheduleFromFarmerToBank: "Calendario de amortizacion del agricultor al banco.",
            requestAdditionalInformation: "Solicitar informacion adicional",
            restoreDefault: "Restaurar predeterminado",
            search: "Buscar",
            select: "Seleccionar",
            selectFileToUploadTheContract: "Seleccione el archivo para cargar el contrato",
            selectNoIfYouHaveAlreadySignedTheContractWithTheApplicantFarmerSelectYesIfYouWantTheApplicantFarmerToSignTheLoanContractOnHisDimitraMobileApp: "Seleccione No si ya firmo el contrato con el solicitante (agricultor). Seleccione SI si desea que el solicitante (agricultor) firme el contrato de prestamo en la app movil Dimitra.",
            send: "Enviar",
            sendToBank: "Enviar al banco",
            sentToBank: "Enviado al banco",
            signedOffline: "Firmado fuera de linea",
            soilAnalysisReport: "Informe de analisis de suelo",
            someDisclaimerOrShortExplainerAboutFollowingReports: "Breve aviso o explicacion sobre los informes siguientes.",
            srd: "SRD",
            startDate: "Fecha de inicio",
            status: "Estado",
            statusLegend: "Leyenda de estados",
            submissionDate: "Fecha de envio",
            success: "Exito",
            tapTheMapToExpandIt: "Toque el mapa para ampliarlo.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponses: "Esta seccion muestra las solicitudes de informacion adicional enviadas al agricultor y sus respuestas.",
            thisSectionShowsAdditionalInformationRequestsSentToTheFarmerAndTheirResponsesYouWillBeNotifiedWhenTheFarmerUpdatesTheApplication: "Esta seccion muestra las solicitudes de informacion adicional enviadas al agricultor y sus respuestas. Se le notificara cuando el agricultor actualice la solicitud.",
            totalInstallments: "Total de cuotas",
            totalInterestApprox: "Interes total (aprox.)",
            totalLoanAmount: "Monto total del prestamo",
            totalPayment: "Pago total",
            totalRepayment: "Amortizacion total",
            transactionIdAndDate: "ID de transaccion y fecha",
            typeYourLocationNameAddress: "Escriba el nombre o la direccion de su ubicacion",
            upcoming: "Proximo",
            uploadTheUnsignedContractAfterYouAttachAndSaveItWillBeSentToTheFarmerToSignYouLlReceiveANotificationOnceItSSigned: "Cargue el contrato sin firmar. Tras adjuntar y guardar, se enviara al agricultor para firmar. Recibira una notificacion cuando este firmado.",
            user: "Usuario",
            userDetails: "Datos del usuario",
            userRole: "Rol del usuario",
            validation: "Validacion",
            viewFullReport: "Ver informe completo",
            viewGeolocation: "Ver geolocalizacion",
            villageTownCity: "Pueblo / Ciudad",
            waitingSignatures: "En espera de firmas",
            warning: "Advertencia",
            year2025: "2025",
            year2026: "2026",
            yesAttachTheContractAndWeLlSendItToTheFarmerToSignInTheApp: "Si: adjunte el contrato y lo enviaremos al agricultor para firmarlo en la app",
            yieldPredictionReport: "Informe de prediccion de rendimiento",
            youMayUploadTheSignedContractForYourRecordsOrLeaveEmptyIfTheContractIsPrivateOrSignedOffline: "Puede cargar el contrato firmado para sus registros o dejarlo vacio si el contrato es privado o se firmo fuera de linea.",
            yourRequestHasBeenSentTheFarmerWillBeNotified: "Su solicitud ha sido enviada. Se notificara al agricultor.",
            yieldForecastChartAria: "Grafico de pronostico de rendimiento",
            yearsAxisLabel: "Anos",
            soilAnalysisSectionTitle: "Analisis de suelo",
            soilMetricNitrogenN: "Nitrogeno (N)",
            soilMetricPhosphorusP: "Fosforo (P2O5)",
            soilMetricPotassiumK: "Potasio (K2O)",
            soilAnalysisPlaceholderTitle: "Que significa esto (marcador de posicion)",
            soilAnalysisPlaceholderBody: "Esta pagina muestra un resumen simplificado de nutrientes del suelo. Cuando se integre la fuente de datos del backend, esta seccion podra ampliarse con graficos completos del perfil del suelo y recomendaciones.",
            landSuitabilitySectionTitle: "Idoneidad del terreno",
            overallSuitabilityScoreLabel: "Puntuacion global de idoneidad",
            suitabilityFactorsPlaceholder: "Factores de idoneidad (marcador de posicion)",
            factorSoilQuality: "Calidad del suelo",
            factorClimateFit: "Adecuacion climatica",
            factorWaterAvailability: "Disponibilidad de agua",
            factorRiskFactors: "Factores de riesgo",
            landSuitabilityExpertFooter: "La IA puede equivocarse; verifique con expertos agronomicos locales antes de decidir.",
        },
        banks: {
            title: 'Bancos',
            addNewBank: 'Agregar nuevo banco',
            bankDetails: 'Detalles del banco',
            bank: 'Banco',
            bankTitle: 'Titulo del banco',
            attachBankLogo: 'Adjuntar logotipo del banco',
            addImage: 'Agregar imagen',
            contactDetails: 'Detalles de contacto',
            firstName: 'Nombre',
            lastName: 'Apellido',
            email: 'Correo electronico',
            phone: 'Numero de telefono',
            enterHere: 'Ingrese aqui',
            apiIntegrationInfo: 'Informacion de integracion API',
            apiBaseUrl: 'URL base de la API',
            clientId: 'ID de cliente / Clave publica',
            clientSecret: 'Secreto del cliente / Clave privada',
            accountAdminCredentials: 'Credenciales de cuenta/administrador',
            adminUsername: 'Usuario administrador',
            password: 'Contrasena',
            require2FA: 'Requerir 2FA',
            enable: 'Habilitar',
            copy: 'Copiar',
            regenerate: 'Regenerar',
            edit: 'Editar',
            back: 'Volver',
            cancel: 'Cancelar',
            save: 'Guardar',
            firstNameInfo: 'Informacion del nombre',
            lastNameInfo: 'Informacion del apellido',
            emailInfo: 'Informacion del correo electronico',
            phoneInfo: 'Informacion del numero de telefono',
            apiBaseUrlInfo: 'Informacion de la URL base de la API',
            clientIdInfo: 'Informacion del ID de cliente',
            clientSecretInfo: 'Informacion del secreto del cliente',
            adminUsernameInfo: 'Informacion del usuario administrador',
            passwordInfo: 'Informacion de la contrasena',
            contactPerson: 'Persona de contacto',
            management: 'Gestion financiera',
            editBank: 'Editar banco',
            changeImage: 'Cambiar imagen',
            failedToLoadBankDetails: 'No se pudieron cargar los detalles del banco',
            bankUpdatedSuccessfully: 'Banco actualizado correctamente',
            bankCreatedSuccessfully: 'Banco creado correctamente',
            errorUpdatingBank: 'Error al actualizar el banco',
            errorCreatingBank: 'Error al crear el banco',
            bankLogo: 'Logotipo del banco',
            bankLogoPreview: 'Vista previa del logotipo del banco',
            notAvailable: 'N/D',
        },
        dashboard: {
            title: "Panel de finanzas",
            avgLoanAmount: "Monto promedio del prestamo",
            vsLastMonth: "vs mes pasado",
            totalApplications: "Solicitudes totales",
            approvalRate: "Tasa de aprobacion",
            loanApplicationsChart: "Solicitudes de prestamo",
            applicationsByStatus: "Solicitudes por estado",
            applicationsByRegion: "Solicitudes por region",
            regionBreakdown: "Desglose por region",
            averageLoanAmountTrend: "Tendencia del monto promedio del prestamo",
            loanAmountOverTime: "Monto del prestamo a lo largo del tiempo",
            avgAmount: "Monto promedio"
        },
        status: {
            approved: "Aprobado",
            pending: "Pendiente",
            waiting: "En espera",
            rejected: "Rechazado"
        },
        reports: {
            today: "Hoy",
            week: "Semana",
            month: "Mes",
            year: "Ano"
        },
    },
}
